// -- FIELDS
const _FIELDS = [
  {
    name: "logo",
    type: "image",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    }
  },
  {
    label: "Nome",
    name: "nome",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Email",
    name: "email",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required", "email"]
  },
  {
    label: "Contacto",
    name: "telefone",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: []
  },
  {
    type: "dcl",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: ["required"]
  },
  {
    label: "Morada",
    name: "morada",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: []
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "E-Mail",
    align: "left",
    value: "email"
  },
  {
    text: "Contacto",
    align: "left",
    value: "telefone"
  },
  {
    text: "Localidade",
    align: "left",
    value: "distrito"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const INSTITUICAO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default INSTITUICAO
